<template>
  <div>
    <div style="margin:15px 0">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/couponPackage' }">券包管理</el-breadcrumb-item>
        <el-breadcrumb-item>新增券包</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div>
      <el-input placeholder="搜索" v-model="area_name" @change="search">
      </el-input>
      <div style="margin-top:20px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="景区名称">
            <template slot-scope="scope">
              <span>{{ scope.row.area_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="picture_url" label="图片">
            <template slot-scope="scope">
              <img v-if="scope.row.area_pic" :src="scope.row.area_pic" alt="" style="width:80px;height:80px">
              <img src="../assets/zhanwei.png" alt="" v-if="!scope.row.area_pic" style="width:80px;height:80px">
            </template>
          </el-table-column>
          <el-table-column label="景区评级">
            <template slot-scope="scope">
              <span>{{ scope.row.area_leavel }}</span>
            </template>
          </el-table-column>
          <el-table-column label="语音价格">
            <template slot-scope="scope">
              <span>{{ scope.row.voice_price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="add(scope.row)">添加券包</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
                     layout="total,  prev, pager, next, jumper"
                     :total="total" style="text-align:right;margin:0 16px 10px 0;border-radius:20px;">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import qs from "qs";

export default {
  props: {
    pageSize: {
      type: Number,
      default: 10,
    }
  },
  data() {
    return {
      total: 0,
      tableData: [],
      packageName: '',
      currentPage: 1,      //分页
      mulSelectIds: [],
      // packagePriceNumber: [],     //套餐价格输入框
      scenicSpotNumber: 0,
      originalPrice: 0,//合计原价格累计
      packageTotalPrice: 0,
      newAddDialogVisible: false,
      newAddForm: {
        marketName: '',
        marketAddress: '',
        name: '',
        phone: ''
      },
      newAddRules: {
        marketName: [
          {required: true, message: '请输入套餐名称', trigger: 'blur'},
        ]
      },
      formLabelWidth: '120px',
      area_name: undefined
    }
  },
  methods: {
    add(data) {
      this.$datas.couponPackage.couponsRule = undefined;
      this.$router.push({
        path: "/coupons",
        query: {type: 0, area_id: data.area_id, area_name: data.area_name}
      });
    },
    search(val){
      this.findScenicSpot();
    },
    //查询景点
    findScenicSpot() {
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var salesInfoData = {
        count: true,
        // area_id: that.areaID,
        // orderby: "area_id desc",
        area_name: this.area_name,
        pageindex: this.currentPage,
        pagesize: 10
      };
      var salesInfoParams = {
        methodUrl: "/admin/getScenicArea",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
          function (res) {
            //成功之后处理逻辑
            that.tableData = res.data.list;
            that.total = res.data.totalcount;
          },
          function (res) {
            //失败之后处理逻辑
            console.log("error:");
          }
      );
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.findScenicSpot();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.findScenicSpot();
    },
  },
  mounted() {
    this.findScenicSpot()
  }
}
</script>

<style>
p span {
  margin: 0 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/scenicList.vue